import { render } from "./ServiceSidebar.vue?vue&type=template&id=34249c18&scoped=true"
import script from "./ServiceSidebar.vue?vue&type=script&lang=js"
export * from "./ServiceSidebar.vue?vue&type=script&lang=js"

import "./ServiceSidebar.vue?vue&type=style&index=0&id=34249c18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34249c18"]])

export default __exports__